import { api } from "./api";
import { ISearchparams } from "@/shared/interfaces/patientPage";

export async function getAllPatients(
    limit?: number,
    page?: number,
    sort?: string,
) {
    const params: ISearchparams = {};
    if (page) params.page = page;
    if (limit) params.limit = limit;
    if (sort) params.sort = sort;

    const queryString = new URLSearchParams(
        Object.entries(params).reduce((acc, [key, value]) => {
            if (value !== undefined) acc[key] = String(value);
            return acc;
        }, {} as Record<string, string>),
    ).toString();

    try {
        const response = await api.get(`patients?${queryString}`, {
            withCredentials: true,
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return { message: "Щось пішло не так" };
        }
    }
}

export async function getSelectedEntity(id: string, lokalString: string) {
    try {
        const response = await api.get(`${lokalString}/${id}`, {
            withCredentials: true,
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return { message: "Щось пішло не так" };
        }
    }
}
